import { render } from "./sinEmpresa.vue?vue&type=template&id=495397fd&scoped=true"
import script from "./sinEmpresa.vue?vue&type=script&lang=js"
export * from "./sinEmpresa.vue?vue&type=script&lang=js"

import "./sinEmpresa.vue?vue&type=style&index=0&id=495397fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495397fd"]])

export default __exports__